import React from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import {
    FaPhoneAlt,
    FaEye,
    FaRegHeart,
    FaRegPaperPlane,
    FaThumbsUp, FaVideo} from "react-icons/fa";
import profile from "../../CandidateCard/Images/doctor profile.png";
import "./CandidateCard4.css"; // Custom styles

function CandidateCard4() {
    return (
        <Container fluid className="p-3">
            <Card className="shadow-lg p-4 mx-auto candidate-card">
                <h2 className="text-center fw-bold mb-4">Candidate (Doctor) Posting Detail</h2>

                <Card className="info-card">
                    <Row>
                        {/* Profile Section */}
                        <Col md={4} xs={12} className="text-center position-relative">
                            <div className="badge-new">New</div>
                            <div className="mt-4 d-flex justify-content-center">
                                <Image
                                    src={profile}
                                    roundedCircle
                                    fluid
                                    className="profile-img"
                                />
                            </div>
                            <h5 className="mt-3 fw-bold text-success" style={{fontSize:"30px"}}>Direct</h5>
                        </Col>

                        {/* Info Section */}
                        <Col md={8} xs={12} className="info-section">
                            <div className="mb-2 fw-bold candidate-name">
                                Dr. Yasmin | 29 years
                            </div>
                            <ul className="list-unstyled mb-3 doctor-points">
                                <li><span className="text-success fw-semibold">• Neurologist • MBBS | MD | MS</span></li>
                                <li>• Country License - OMSB | QCHP</li>
                                <li>• 9 Years Experience</li>
                                <li>• Joining - Immediately</li>
                                <li>• Nationality - Indian</li>
                                <li>• Current Location - India</li>
                            </ul>
                            <div className="d-flex flex-wrap gap-2 action-buttons">
                                <Button variant="outline-primary" className="flex-fill d-flex align-items-center justify-content-center gap-1">
                                    <FaRegHeart />
                                </Button>
                                <Button variant="dark" className="flex-fill d-flex align-items-center justify-content-center gap-1">
                                    <FaPhoneAlt /> Call
                                </Button>
                                <Button variant="primary" className="flex-fill d-flex align-items-center justify-content-center gap-1">
                                    <FaEye /> View
                                </Button>
                                <Button variant="success" className="flex-fill d-flex align-items-center justify-content-center gap-1">
                                    <i className="bi bi-whatsapp"></i> WhatsApp
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* Footer Actions */}
                <Card className="footer-card">
                    <Row className="text-center mt-3">
                        <Col xs>
                            <Card className="footer-item">
                                <div className="d-flex justify-content-center align-items-center gap-1">
                                    <FaThumbsUp className="fs-5" />
                                    <span>Likes</span>
                                </div>
                            </Card>
                        </Col>
                        <Col xs>
                            <Card className="footer-item">
                                <div className="d-flex justify-content-center align-items-center gap-1">
                                    <span>Repost</span>
                                </div>
                            </Card>
                        </Col>
                        <Col xs>
                            <Card className="footer-item">
                                <div className="d-flex justify-content-center align-items-center gap-1">
                                    <FaRegPaperPlane className="fs-5" />
                                    <span>Share</span>
                                </div>
                            </Card>
                        </Col>
                        <Col xs>
                            <Card className="footer-item">
                                <div className="d-flex justify-content-center align-items-center gap-1">
                                    <FaRegHeart className="fs-5" />
                                    <span>Message</span>
                                </div>
                            </Card>
                        </Col>
                        <Col xs>
                            <Card className="footer-item">
                                <div className="d-flex justify-content-center align-items-center gap-1">
                                    <span>Report</span>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Card>
            </Card>
        </Container>
    );
}

export default CandidateCard4;
